import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import AboutSection from './AboutSection';
import AboutSectionBranched from '../AboutSection.deviation_gruser';
import AboutSectionContainer from './AboutSection.container';

export default withFeatureBranch({
  deviation_gruser_port: AboutSectionBranched,
})(AboutSectionContainer(AboutSection));
